<template>
  <div class="footer"
       :style="{padding: locals.getItem('language') =='en'?'20px 0 ':'20px'}">
    <p>{{$t('footer.content_one')}}</p>
    <p>{{$t('footer.content_add')}}</p>
    <p><span>{{$t('footer.content_two')}}</span>
       <a href="https://beian.miit.gov.cn/" target="_blank"><span>{{$t('footer.content_icp')}}</span></a> | 
       <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037832" target="_blank"><span>{{$t('footer.content_goan')}}</span></a>
    </p>
  </div>
</template>

<script>
const locals = localStorage
export default {
  data() {
    return { locals }
  },
}
</script>

<style>
</style>